import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x: any) => x.msg).join("; ");
  return d || e?.message || "Something went wrong";
}

export function useApi() {
  const { getToken } = useAuth();
  const ref = useRef(getToken);
  ref.current = getToken;
  return useCallback(async (method: string, path: string, data?: any) => {
    const token = await ref.current();
    const res = await axios({ method, url: API + path, data, headers: token ? { Authorization: `Bearer ${token}` } : {} });
    return res.data;
  }, []);
}

export function useLoad<T = any>(path: string | null) {
  const api = useApi();
  const [state, setState] = useState<{ data: T | null; loading: boolean; error: string | null }>({
    data: null, loading: !!path, error: null,
  });
  const reload = useCallback(async () => {
    if (!path) return;
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const data = await api("get", path);
      setState({ data, loading: false, error: null });
    } catch (e) {
      setState({ data: null, loading: false, error: errMsg(e) });
    }
  }, [api, path]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { ...state, reload };
}

export function useTaxonomy() {
  const cats = useLoad<any[]>("/public/categories");
  const areas = useLoad<any[]>("/public/areas");
  const catName = (id: string) => cats.data?.find((c) => c.id === id)?.name || "—";
  const areaName = (id: string) => areas.data?.find((a) => a.id === id)?.name || "—";
  return { categories: cats.data || [], areas: areas.data || [], catName, areaName };
}

export const fmt = (iso?: string) => (iso ? new Date(iso).toLocaleString() : "—");

export const qs = (o: Record<string, string>) => Object.entries(o).filter(([, v]) => v).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");

export const FIELD_LABELS: Record<string, string> = {
  full_name: "Full name", phone: "Phone", email: "Email", address: "Address", notes: "Private notes",
};
